BehaviorAdapt(1920, 1080, 30);